import dayjs from "lib/dayjs";

/**
 * Dollar-day-weighted quoted rate for an SLGS portfolio.
 *
 * SLGS certificate rates are simple annual rates. Weighting each quoted rate
 * by principal and actual days invested keeps the portfolio result directly
 * comparable with the rates shown for the individual positions.
 */
export function computeSlgsDollarDayWeightedRate(
  investments = [],
  settlementDate
) {
  const settlement = dayjs(settlementDate);
  if (!settlement.isValid()) return null;

  let weightedRate = 0;
  let dollarDays = 0;

  investments.forEach((position) => {
    const maturity = dayjs(position?.maturityDate);
    const principal = Number(position?.principal);
    const ratePct = Number(position?.ratePct);
    const days = maturity.isValid() ? maturity.diff(settlement, "day") : 0;

    if (
      !Number.isFinite(principal) ||
      principal <= 0 ||
      !Number.isFinite(ratePct) ||
      days <= 0
    ) {
      return;
    }

    const weight = principal * days;
    weightedRate += ratePct * weight;
    dollarDays += weight;
  });

  return dollarDays > 0 ? weightedRate / dollarDays : null;
}
